import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { ITokenBasedSessionService } from '@studyportals/student-interfaces';
import { IStudent, StudentField } from '@studyportals/studentdomain';
import { Actor, StudentRepositoryStateType } from '../../../interfaces';
import { CatchReportAsyncException } from '../../decorators/error-decorators';
import { Deferred } from '../deferred';
import { StudentRepository } from '../student-repository';
import { StudentRepositoryState } from './student-repository-state';

export class PendingStudentRepositoryState
	extends StudentRepositoryState
{
	private state?: StudentRepositoryState;
	private lock: Deferred;

	constructor(
		eventAggregationService: IEventAggregationService,
		studentRepository: StudentRepository
	) {
		super(StudentRepositoryStateType.PENDING, eventAggregationService, studentRepository);
		this.lock = new Deferred();
	}

	public  initialize(): void {
		// Initialize pending state
	}

	public async setStudentData(studentData: IStudent, actor: Actor): Promise<void> {
		await this.lock.untilOpen();
		return this.state!.setStudentData(studentData, actor);
	}

	public async getStudentData(studentFields: StudentField[]): Promise<IStudent> {
		await this.lock.untilOpen();
		return this.state!.getStudentData(studentFields);
	}

	public async addToCollection(type: StudentField, items: any[]): Promise<void> {
		await this.lock.untilOpen();
		return this.state!.addToCollection(type, items);
	}

	public async removeFromCollection(type: StudentField, items: any[]): Promise<void> {
		await this.lock.untilOpen();
		return this.state!.removeFromCollection(type, items);
	}

	public async replaceCollection(type: StudentField, items: any[]): Promise<void> {
		await this.lock.untilOpen();
		return this.state!.replaceCollection(type, items);
	}

	@CatchReportAsyncException
	public async onSessionServiceReady(sessionService: ITokenBasedSessionService): Promise<void> {
		const session = await sessionService.getSession();

		const online = this.studentRepository.onlineState;
		const offline = this.studentRepository.offlineState;

		this.state = session === null ? offline : online;

		this.studentRepository.updateState(this.state);
		this.lock.open();

		if (this.state === online) {
			await offline.syncData();
		}
	}
}
